@if (hasSteps()) {
  <ol class="approval-steps">
    @for (row of rows(); track row.step; let isLast = $last) {
      <li class="approval-steps__node" [class.approval-steps__node--last]="isLast">
        <span class="approval-steps__marker" aria-hidden="true">{{ row.step }}</span>
        <span class="approval-steps__body">
          @if (row.groupName) {
            <span class="approval-steps__approver">
              <span class="approval-steps__approver-name">{{ row.groupName }}</span>
              <span class="approval-steps__approver-kind">
                {{ 'app.catalog.approvalSteps.groupSuffix' | translate }}
              </span>
              <button
                type="button"
                class="approval-steps__info"
                [attr.aria-label]="'app.catalog.approvalSteps.groupTooltipAria' | translate"
                [matTooltip]="
                  'app.catalog.approvalSteps.groupTooltip' | translate: { group: row.groupName }
                "
                matTooltipPosition="above"
              >
                <mat-icon class="approval-steps__info-icon">info</mat-icon>
              </button>
            </span>
          } @else if (row.approverName) {
            <span class="approval-steps__approver">
              <span class="approval-steps__approver-name">{{ row.approverName }}</span>
              @if (row.approverEmail) {
                <span class="approval-steps__approver-email">{{ row.approverEmail }}</span>
              }
            </span>
          } @else {
            <span class="approval-steps__approver approval-steps__approver--unresolved">
              {{ 'app.catalog.demand.workflow.types.' + (row.type || 'fallback') | translate }}
            </span>
          }
        </span>
        @if (!isLast) {
          <span class="approval-steps__connector" aria-hidden="true"></span>
        }
      </li>
    }
  </ol>
} @else {
  <av-status-pill
    variant="muted"
    [label]="'app.catalog.approvalSteps.noneRequired' | translate"
  ></av-status-pill>
}
